import React, { useEffect, useRef, useState } from "react";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import StudentCharacterCertificate1 from "../components/StudentCharacterCertificate1";
import StudentCharacterCertificateManual from "../components/StudentCharacterCertificateManual";
import {
  printElement,
  printImg,
  printManualCertificate,
} from "../master/Print";
import IdCardLayout from "./IdCardLayout";
import { imgBaseUrl } from "../../api/api";
import usePrivateLink from "../config/usePrivateLink";

export default function StudentCharacterCertificate() {
  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [batchData, setBatchData] = useState({});
  const [students, setStudents] = useState([]);
  const [mode, setMode] = useState("batch"); // "batch" | "manual"
  const manualCertRef = useRef(null);
  const hasAccess = usePrivateLink();


  const getBatchList = async () => {
    setLoading(true);
    try {
      const response = await batchList();
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchInfo = async (id) => {
    setLoading(true);
    try {
      let addUrl = `&id=${id}&status=1`;
      const response = await batchDetailsWithStudents(addUrl);
      if (response.data.status) {
        setBatchData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatchList();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <IdCardLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12 d-flex justify-content-between align-items-center">
                            <h4 className="text-primary m-0">
                              Student Character Certificate
                            </h4>
                            <div>
                              <button
                                className={`btn btn-sm me-2 ${mode === "batch"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                onClick={() => setMode("batch")}
                              >
                                From Batch
                              </button>
                              <button
                                className={`btn btn-sm ${mode === "manual"
                                  ? "btn-primary"
                                  : "btn-outline-primary"
                                  }`}
                                onClick={() => setMode("manual")}
                              >
                                Manual Certificate
                              </button>
                            </div>
                          </div>
                          <div className="col-12">
                            <hr />
                          </div>

                          {mode === "batch" && (
                            <>
                              <div className="col-4">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="batch_id"
                                    onChange={(e) => {
                                      setBatchData([]);
                                      getBatchInfo(e.target.value);
                                    }}
                                  >
                                    <option value="" selected disabled>
                                      Select Batch
                                    </option>
                                    {batches?.map((batch, i) => (
                                      <option key={i} value={batch?.id}>
                                        {batch?.title} ({batch?.course?.title})
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="batch_id">Select Batch</label>
                                </div>
                              </div>
                              {batchData?.active_batch_students && (
                                <div className="col-4">
                                  <div className="form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="student_id"
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        if (value === "all") {
                                          setStudents(
                                            batchData?.active_batch_students ||
                                            [],
                                          );
                                        } else {
                                          setStudents(
                                            batchData?.active_batch_students?.filter(
                                              (student) =>
                                                student?.student_id ===
                                                Number(value),
                                            ) || [],
                                          );
                                        }
                                      }}
                                    >
                                      <option value="" selected disabled>
                                        Select Student
                                      </option>
                                      {batchData?.active_batch_students?.map(
                                        (student, i) => (
                                          <option
                                            key={i}
                                            value={student?.student_id}
                                          >
                                            {student?.student_info?.name} (
                                            {
                                              student?.student_info
                                                ?.registration_no
                                            }
                                            )
                                          </option>
                                        ),
                                      )}
                                    </select>
                                    <label htmlFor="student_id">
                                      Select Student
                                    </label>
                                  </div>
                                </div>
                              )}

                              <div className="col-3">
                                {hasAccess("/card/certificate/print") && (

                                  <button
                                    className="btn btn-primary"
                                    onClick={() => printElement("PrintDiv")}
                                  >
                                    Print
                                  </button>
                                )}
                              </div>

                              <div className="col-12">
                                <hr />
                              </div>

                              <div
                                className="col-12 a4-page d-flex flex-wrap align-content-center gap-5"
                                id="PrintDiv"
                              >
                                {students?.map((student, i) => (
                                  <StudentCharacterCertificate1
                                    data={student}
                                    batch={batchData}
                                    key={i}
                                  />
                                ))}
                              </div>
                            </>
                          )}

                          {mode === "manual" && (
                            <>
                              <div className="col-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={() => {
                                    const data =
                                      manualCertRef.current?.getPrintData();
                                    if (data)
                                      printManualCertificate(
                                        data.form,
                                        data.setting,
                                        imgBaseUrl,
                                      );
                                  }}
                                >
                                  Print
                                </button>
                              </div>

                              <div className="col-12">
                                <hr />
                              </div>

                              <StudentCharacterCertificateManual
                                ref={manualCertRef}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
